import Hero from './Components/Hero';
import Contact from './Components/Contact';
import Partners from './Components/Partners';
import ClearBoxSection from './Components/ClearBoxSection';
import TailoredRingSection from './Components/TailoredRingSection';

export default function Home() {
    return (
        <>
            <Hero />
            <ClearBoxSection />
            <TailoredRingSection />
            {/* <ChatAlloySection /> deprecated */}
            <Partners />
            <Contact />
        </>
    );
}